import { Checkbox, Collapse, Flex, Radio } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { useStepReportType } from './SectionReportTypeRequest.hooks';
import { messages } from './SectionReportTypeRequest.messages';
import { SectionReportTypeRequestProps } from './SectionReportTypeRequest.types';

export const SectionReportTypeRequest = memo<SectionReportTypeRequestProps>((props) => {
    const { reportConfig, onReportConfigChange } = props;

    const {
        integration,
        integrationName,
        integrationTemplates,
        otherIntegrationTemplates,
        standaloneTemplates,
        values,
        templateOptions,
        handleTemplateToggle,
    } = useStepReportType(reportConfig, onReportConfigChange);

    if (!templateOptions.length) {
        return null;
    }

    return (
        <Flex direction='column'>
            {integration && integrationTemplates.length > 0 && (
                <Collapse
                    localStorageKey='workflows-request'
                    bordered
                    radius='small'
                    spacing='0 24 16 24'
                    name={messages.sectionTitleIntegrations({ integrationName })}
                >
                    <Flex direction='column' spacing='12'>
                        {integrationTemplates.map((template) => (
                            <Checkbox
                                checked={values?.includes(template.id)}
                                onChange={() => handleTemplateToggle(template)}
                                key={template.id}
                            >
                                {template.text}
                            </Checkbox>
                        ))}
                    </Flex>
                </Collapse>
            )}

            {integration && otherIntegrationTemplates.length > 0 && (
                <Collapse
                    localStorageKey='others-request'
                    bordered
                    radius='small'
                    spacing='0 24 16 24'
                    name={messages.sectionTitleOtherIntegrations}
                >
                    <Flex direction='column' spacing='12'>
                        {otherIntegrationTemplates.map((template) => (
                            <Radio
                                checked={values?.includes(template.id)}
                                onChange={() => handleTemplateToggle(template)}
                                key={template.id}
                            >
                                {template.text}
                            </Radio>
                        ))}
                    </Flex>
                </Collapse>
            )}

            {standaloneTemplates.length > 0 && (
                <Collapse
                    localStorageKey='standalone-request'
                    bordered
                    radius='small'
                    spacing='0 24 16 24'
                    name={messages.sectionTitleStandalone}
                >
                    <Flex direction='column' spacing='12'>
                        {standaloneTemplates.map((template) => (
                            <Checkbox
                                checked={values?.includes(template.id)}
                                onChange={() => handleTemplateToggle(template)}
                                key={template.id}
                            >
                                {template.text}
                            </Checkbox>
                        ))}
                    </Flex>
                </Collapse>
            )}
        </Flex>
    );
});

SectionReportTypeRequest.displayName = 'SectionReportTypeRequest';
